import { Alert, Button, LinearProgress, Paper, Stack } from "@mui/material";
import { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import CenterScreen from "../../../../../components/wrappers/CenterScreen";
import AuthFooter from "../../../../auth/login/component/AuthFooter";
import { ErrorMessage } from "../../../../saps/components/display/NotFound";
import { useGetQrCodeRedirectUrl } from "./hook/useGetQrCodeRedirectUrl";
import { normalizeWebsiteUrl } from "../../../../../utils/UrlValidation";

export default function QrRedirectPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { data, isLoading, error } = useGetQrCodeRedirectUrl(id);
  const finalUrl = normalizeWebsiteUrl(data);

  useEffect(() => {
    if (finalUrl) window.location.replace(finalUrl);
  }, [finalUrl]);

  if (isLoading) {
    return (
      <Fragment>
        <CenterScreen minHeight="78vh">
          <LinearProgress sx={{ width: "100%" }} />
        </CenterScreen>
        <AuthFooter />
      </Fragment>
    );
  }

  if (error) {
    return (
      <Fragment>
        <CenterScreen minHeight="78vh">
          <ErrorMessage
            title={t("SomethingWentWrong")}
            subtitle={t("FailedToFetchQRCode")}
            showBackButton={false}
          />
        </CenterScreen>
        <AuthFooter />
      </Fragment>
    );
  }

  if (!finalUrl) {
    return (
      <Fragment>
        <CenterScreen minHeight="78vh">
          <ErrorMessage
            title={t("SomethingWentWrong")}
            subtitle={t("FailedToFetchQRCode")}
            showBackButton={false}
          />
        </CenterScreen>
        <AuthFooter />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <CenterScreen minHeight="78vh">
        <Paper sx={{ p: 4, width: { xs: "90%", md: "35%" } }}>
          <Stack spacing={3} justifyContent="center" alignItems="center">
            <Alert severity="info" sx={{ width: "100%" }}>
              {t("QrRedirectExplanationAlert")}
            </Alert>
            <Button
              type="button"
              variant="contained"
              sx={{ width: "100%" }}
              onClick={() => window.location.replace(finalUrl)}
            >
              {t("QrRedirectOpenLinkButton")}
            </Button>
          </Stack>
        </Paper>
      </CenterScreen>
      <AuthFooter />
    </Fragment>
  );
}
